import React from "react";

import { useUserContext, useUserDispatchContext } from "../context/User";
import { getProfileIcon } from "../services/icons";

export default function UserToolbar() {
  const { user, logout } = useUserContext();
  const userDispatch = useUserDispatchContext();

  const setOverviewPage = () => {
    userDispatch({ type: "set-page", payload: { page: "overview" } });
  };

  if (!user.accessToken || !user.profile) {
    return null;
  }

  return (
    <div className="bg-[#131313]" id="user-bar">
      <div className="font-barlowlight text-[#FFF]">
        <div className="flex flex-row items-center justify-between px-5 py-2.5">
          <div className="flex flex-row items-center gap-2">
            <span className="h-[10px] w-[10px] rounded-full bg-[#066B28]" /> {user.profile.title}
          </div>
          <div className="flex flex-row items-center gap-5">
            <div className="cursor-pointer" onClick={() => logout()}>
              Logout
            </div>
            {user && user.profile.role === "shelter" && (
              <div
                className={`flex h-[42px] w-[42px] cursor-pointer items-center justify-center rounded-full hover:bg-[#2C2619] ${
                  user.page === "overview" ? "bg-[#2C2619]" : "bg-[#1B1B1B]"
                }`}
                onClick={setOverviewPage}
              >
                {getProfileIcon()}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
